import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=382f6f8f&scoped=true"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"
import style0 from "./Solutions.vue?vue&type=style&index=0&id=382f6f8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f6f8f",
  null
  
)

export default component.exports